// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2FTx8","label":"Labeled_label__3i4ZG","divider":"Labeled_divider__21mbK"};